"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const binary_1 = require("../binary");
class TwingNodeExpressionBinaryEqual extends binary_1.TwingNodeExpressionBinary {
    compile(compiler) {
        compiler
            .raw('Runtime.compare(')
            .subcompile(this.getNode('left'))
            .raw(', ')
            .subcompile(this.getNode('right'))
            .raw(')');
    }
}
exports.TwingNodeExpressionBinaryEqual = TwingNodeExpressionBinaryEqual;
